import { Chip, Typography } from '@mui/material'
import { SxProps } from '@mui/system'
import { FC } from 'react'

import { useTranslation } from '@/core'

type Props = {
  areaName?: string | null
  sx?: SxProps
}
export const AreaNameChip: FC<Props> = ({ areaName, sx }) => {
  const { t } = useTranslation('gps')

  return areaName ? (
    <Chip
      variant="outlined"
      label={
        <Typography variant="subtitle2">
          {t('areaName', {
            areaName,
          })}
        </Typography>
      }
      sx={sx}
    />
  ) : null
}
